import api from './axios';

/** Auth API surface — login, logout, register, refresh, me. */
export const authApi = {
  async login({ email, password }) {
    const { data } = await api.post('/auth/login', { email, password });
    if (data?.token) localStorage.setItem('lc.token', data.token);
    return data;
  },

  async register(payload) {
    const { data } = await api.post('/auth/register', payload);
    return data;
  },

  async logout() {
    try { await api.post('/auth/logout'); }
    finally { localStorage.removeItem('lc.token'); }
  },

  async me() {
    const { data } = await api.get('/auth/me');
    return data;
  },

  async refresh() {
    const { data } = await api.post('/auth/refresh');
    if (data?.token) localStorage.setItem('lc.token', data.token);
    return data;
  },
};
